import React from 'react';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

import AddControl from 'components/add_control';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image } from 'react-bootstrap';

import './styles.scss';

// DEPRECATED: Delete this in favor of shared/empty_state
const EmptyStatePanel = ({ buttonText, faIcon, iconClassNames, imageSrc, message, onClick }: EmptyStatePanelProps) => {
  return (
    <div className="panel panel-default dashed-border text-center p-5 empty-state">
      <div className={`icons mb-3 ${iconClassNames}`}>
        {faIcon && (
          <FontAwesomeIcon icon={faIcon} />
        )}
        {imageSrc && <Image src={imageSrc} />}
      </div>
      <p>{message}</p>
      <AddControl onClick={onClick}>{buttonText}</AddControl>
    </div>
  );
};

type EmptyStatePanelProps = {
  buttonText?: string,
  faIcon?: IconProp,
  iconClassNames?: string,
  imageSrc?: string,
  message?: string,
  onClick?: () => void,
};

export default EmptyStatePanel;
